import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav, NavItem, Button } from 'react-bootstrap';
import './MobileGameHeader.css';
import PatronAssets from 'containers/PatronAssets';
import { tournamentShape } from 'utils/shapes';
import { padNumber, fromIso9075DateString } from 'utils/functions';
import Countdown from 'react-countdown-now';
import PointValueDisplay from 'components/PointValueDisplay';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';

const renderer = ({ days, hours, minutes, seconds }) => {
  return (
    <span>{`${padNumber(days)}:${padNumber(hours)}:${padNumber(
      minutes
    )}:${padNumber(seconds)}`}</span>
  );
};

class MobileGameHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLeaderboard: false,
      browserMillis: 0
    };

    this.toggleLeaderboard = this.toggleLeaderboard.bind(this);
  }

  toggleLeaderboard() {
    const { showLeaderboard } = this.state;
    const { toggleLeaderboard } = this.props;

    this.setState({
      showLeaderboard: !showLeaderboard
    });

    if (toggleLeaderboard) {
      toggleLeaderboard(!showLeaderboard);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { tournament } = nextProps;
    const { browserMillis } = this.state;

    if (tournament && browserMillis === 0) {
      this.setState({
        browserMillis: moment().valueOf()
      });
    }
  }

  render() {
    const {
      tournament,
      onTournamentEnd,
      playerScore,
      playerTotalRank
    } = this.props;
    const { showLeaderboard, browserMillis } = this.state;

    const leaderboardIsActive = showLeaderboard ? ' active' : '';

    const tournamentMillis = tournament
      ? moment.utc(tournament.endTime).valueOf()
      : moment().valueOf();
    const serverMillis = tournament
      ? parseInt(tournament.serverTime, 10)
      : moment().valueOf();

    const countdown = tournamentMillis - serverMillis + browserMillis;

    return (
      <div className="mobile-game-header">
        <Navbar fixedTop fluid>
          <Nav>
            <LinkContainer to="/mobile/games" activeClassName="">
              <NavItem>
                <Button className="navbar-btn mobile-gaming-btn">Back</Button>
              </NavItem>
            </LinkContainer>
            {tournament && (
              <NavItem>
                <span className="player-position">{playerTotalRank}</span>
                <Button
                  className={`navbar-btn dropdown mobile-gaming-dropdown${leaderboardIsActive}`}
                  onClick={this.toggleLeaderboard}
                >
                  Leaderboard
                </Button>
              </NavItem>
            )}
          </Nav>
          {tournament && (
            <Nav className="time-container">
              <NavItem>
                <span className="time-label">ENDS IN</span>
                <span className="time">
                  <Countdown
                    date={countdown}
                    renderer={renderer}
                    onComplete={onTournamentEnd}
                  />
                </span>
              </NavItem>
            </Nav>
          )}
          {tournament ? (
            <Nav className={'gaming-patron-assets'}>
              <NavItem>
                <PointValueDisplay label="Score" pointValue={playerScore} />
              </NavItem>
            </Nav>
          ) : (
            <PatronAssets isGaming={true} />
          )}
        </Navbar>
      </div>
    );
  }
}

MobileGameHeader.propTypes = {
  tournament: tournamentShape,
  toggleLeaderboard: PropTypes.func,
  onTournamentEnd: PropTypes.func,
  playerTotalRank: PropTypes.string,
  playerScore: PropTypes.number
};

export default MobileGameHeader;



// WEBPACK FOOTER //
// ./src/components/MobileGameHeader/index.js